export default __webpack_public_path__ + "static/media/planet.af9b5d80.png";